import type { InvRecord } from './types';
import { t } from '../lib/i18n';

/**
 * One store's inv record, read by key at the daemon (JCD-59).
 *
 * Resolves to null when the part isn't stocked at that store — which also
 * covers a store the user may not read, deliberately indistinguishable from a
 * genuine miss. That is a normal answer, not an error, so the modal shows an
 * empty state rather than a retry card.
 */
export async function fetchInvRecord(
  sid: number, line: string, part: string,
): Promise<InvRecord | null> {
  const q = new URLSearchParams({ sid: String(sid), line, part });
  const res = await fetch(`/api/inv-record?${q}`, { credentials: 'same-origin' });
  if (res.status === 401) throw new Error('unauthenticated');
  if (res.status === 403) throw new Error('forbidden');
  if (res.status === 502 || res.status === 503) throw new Error(t.errors.daemonOffline);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = (await res.json()) as { found?: boolean } & InvRecord;
  return body.found ? body : null;
}
